/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class OrderLineViantAdelphicIDsSetAudienceID {
    'internalAudienceId'?: string;
    'adelphicTaxonomyId'?: string;
    'segmentorJobId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "internalAudienceId",
            "baseName": "internal_audience_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "adelphicTaxonomyId",
            "baseName": "adelphic_taxonomy_id",
            "type": "string",
            "format": "int64"
        },
        {
            "name": "segmentorJobId",
            "baseName": "segmentor_job_id",
            "type": "string",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return OrderLineViantAdelphicIDsSetAudienceID.attributeTypeMap;
    }

    public constructor() {
    }
}

